<template>
  <div class="frame-35734">
    <div class="frame-357341">
      <div class="frame-35735">{{$t("pre-order-value")}}</div>
    </div>
    <div class="frame-2" v-if="paymentHistory?.message === 'SUCCESS'">
      <div class="toggle-button">
        <div
          class="btn1"
          :style="{
            background:
              toggleButtonValue === 'OverView' ? '#224096' : 'transparent',
            color: toggleButtonValue === 'OverView' ? 'white' : '#224096',
          }"
          @click="toggleButtonValue = 'OverView'"
        >
          {{$t("overview-history")}}
        </div>
        <div
          class="btn1"
          :style="{
            background:
              toggleButtonValue === 'TopUp' ? '#224096' : 'transparent',
            color: toggleButtonValue === 'TopUp' ? 'white' : '#224096',
          }"
          @click="toggleButtonValue = 'TopUp'"
        >
          {{$t("top-up")}}
        </div>
      </div>
      <div class="wrapper" v-if="toggleButtonValue === 'OverView'">
        <div class="pre-order-value-wrapper">
          <div class="pre-order-value">{{$t("your-pre-order")}}</div>
          <div class="pre-order-value-2">
            {{$t("view-current-balance")}}
          </div>
        </div>
        <div class="pre-order-value-wrapper">
          <div class="pre-order-value">{{$t("current-balance")}}</div>
          <div class="pre-order-value-2 credits">
            {{
              this.paymentHistory?.creditBalance
                ? this.paymentHistory?.creditBalance
                : 0
            }}
            {{$t("credits")}}
          </div>
        </div>
        <div class="pre-order-value-wrapper">
          <div class="pre-order-value">{{$t("credit-utilize")}}</div>
          <div class="progress-bar">
            <div
              class="progress"
              :style="{
                width: `${creditUtilizationPercentage}%`,
                backgroundColor: '#EFCC3A',
              }"
            ></div>
          </div>
          <div class="pre-order-value">
            {{ creditUtilizationPercentage }}% {{$t("used")}}
          </div>
        </div>
        <div class="pre-order-value-wrapper">
          <div class="pre-order-value">{{$t("subscription-type")}}</div>
          <div class="pre-order-value-2">
            {{
              this.paymentHistory?.creditPlan?.subscriptionType
                ? this.paymentHistory?.creditPlan?.subscriptionType
                : "-"
            }}
          </div>
        </div>
        <div class="pre-order-value-wrapper">
          <div class="pre-order-value">{{$t("validity")}}</div>
          <div class="pre-order-value-2">
            {{
              this.paymentHistory?.creditPlan?.subscriptionValidityDays
                ? this.paymentHistory?.creditPlan?.subscriptionValidityDays
                : "-"
            }}
          </div>
        </div>
        <div class="pre-order-value-wrapper">
          <div class="pre-order-value">{{$t("credit-consumption")}}</div>
          <ul
            class="credit-info"
            v-if="
              this.paymentHistory?.creditPlan?.description &&
              this.paymentHistory?.creditPlan?.description.length
            "
          >
            <li
              class="credit-text"
              v-for="(item, index) in this.paymentHistory?.creditPlan
                ?.description"
              :key="index"
            >
              <span>&#8226;</span> {{ item }}
            </li>
          </ul>
          <p v-else class="credit-text">-</p>
        </div>
        <div class="enterprise-discount" v-if="EntityType === 'CORPORATE'">
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="24"
            height="24"
            viewBox="0 0 24 24"
            fill="none"
          >
            <path
              d="M20 8.25131H16.7113C16.7478 8.22037 16.7853 8.19037 16.8209 8.15756C17.1057 7.9046 17.3351 7.59561 17.495 7.24992C17.6549 6.90423 17.7417 6.52927 17.75 6.1485C17.7623 5.73194 17.6894 5.31726 17.5356 4.92992C17.3819 4.54258 17.1506 4.19075 16.856 3.89603C16.5613 3.6013 16.2096 3.36991 15.8223 3.21605C15.435 3.06219 15.0203 2.98912 14.6038 3.00131C14.2228 3.00951 13.8477 3.09626 13.5018 3.25613C13.156 3.41599 12.8468 3.64553 12.5938 3.93037C12.2436 4.33621 11.9589 4.79422 11.75 5.28787C11.5411 4.79422 11.2564 4.33621 10.9062 3.93037C10.6532 3.64553 10.344 3.41599 9.99818 3.25613C9.65232 3.09626 9.27718 3.00951 8.89625 3.00131C8.47969 2.98912 8.06503 3.06219 7.67774 3.21605C7.29044 3.36991 6.93868 3.6013 6.64405 3.89603C6.34941 4.19075 6.11812 4.54258 5.96438 4.92992C5.81064 5.31726 5.73768 5.73194 5.75 6.1485C5.75833 6.52927 5.84514 6.90423 6.005 7.24992C6.16486 7.59561 6.39434 7.9046 6.67906 8.15756C6.71469 8.1885 6.75219 8.2185 6.78875 8.25131H3.5C3.10218 8.25131 2.72064 8.40934 2.43934 8.69065C2.15804 8.97195 2 9.35348 2 9.75131V12.7513C2 13.1491 2.15804 13.5307 2.43934 13.812C2.72064 14.0933 3.10218 14.2513 3.5 14.2513V20.2513C3.5 20.6491 3.65804 21.0307 3.93934 21.312C4.22064 21.5933 4.60218 21.7513 5 21.7513H18.5C18.8978 21.7513 19.2794 21.5933 19.5607 21.312C19.842 21.0307 20 20.6491 20 20.2513V14.2513C20.3978 14.2513 20.7794 14.0933 21.0607 13.812C21.342 13.5307 21.5 13.1491 21.5 12.7513V9.75131C21.5 9.35348 21.342 8.97195 21.0607 8.69065C20.7794 8.40934 20.3978 8.25131 20 8.25131ZM13.7188 4.92412C13.8375 4.79298 13.9821 4.68781 14.1434 4.61522C14.3047 4.54262 14.4793 4.50415 14.6562 4.50225H14.7022C14.9095 4.50354 15.1145 4.54621 15.3052 4.62775C15.4958 4.70929 15.6683 4.82806 15.8124 4.9771C15.9566 5.12615 16.0695 5.30246 16.1447 5.49572C16.2198 5.68898 16.2556 5.89529 16.25 6.10256C16.2481 6.27946 16.2096 6.45406 16.137 6.6154C16.0644 6.77673 15.9593 6.92131 15.8281 7.04006C14.9384 7.82756 13.4619 8.10506 12.5469 8.20256C12.6594 7.20975 12.9688 5.76693 13.7188 4.92412ZM7.71031 4.95787C8.00088 4.66733 8.39441 4.50325 8.80531 4.50131H8.85125C9.02815 4.50322 9.20275 4.54168 9.36409 4.61428C9.52542 4.68688 9.67 4.79205 9.78875 4.92318C10.5753 5.81193 10.8528 7.28568 10.9503 8.19693C10.0391 8.10318 8.56531 7.82193 7.67656 7.03537C7.54543 6.91662 7.44026 6.77204 7.36766 6.61071C7.29506 6.44938 7.2566 6.27478 7.25469 6.09787C7.24887 5.88715 7.28593 5.67745 7.36361 5.48149C7.44128 5.28552 7.55796 5.10738 7.70656 4.95787H7.71031ZM3.5 9.75131H11V12.7513H3.5V9.75131ZM5 14.2513H11V20.2513H5V14.2513ZM18.5 20.2513H12.5V14.2513H18.5V20.2513ZM20 12.7513H12.5V9.75131H20V12.7513Z"
              fill="#0D630D"
            />
          </svg>
          <div class="enterprise-discount-title">
            {{$t("enterprise-discount")}}
          </div>
        </div>
        <div class="line"></div>
        <div class="pre-order-value-wrapper">
          <div class="pre-order-value">{{$t("usage-history")}}</div>
          <div class="pre-order-value-2">
            {{$t("view-credit-usage")}}
          </div>
          <div class="table-container scrollable">
            <div class="custom-table">
              <div class="custom-table-header" v-if="!this.$root.mobile">
                <div
                  v-for="header in tableHeaders"
                  :key="header"
                  class="custom-table-cell header-cell"
                  :style="{
                    width:
                      header == $t('order-date') ||
                      header == $t('credit-consumed') ||
                      header == $t('balance-credit')
                        ? '12%'
                        : header === $t('order-by') || header === $t('report-type')
                        ? '16%'
                        : header ===$t('company-name')
                        ? '32%'
                        : '',
                  }"
                >
                  {{ header }}
                </div>
              </div>
              <div class="custom-table-body">
                <div
                  v-for="transaction in this.paymentHistory?.transactions"
                  :key="transaction.id"
                  class="custom-table-row"
                >
                  <div v-if="this.$root.mobile" class="grid-container">
                    <div class="title">{{$t("order-date")}}:</div>
                    <div class="value">{{ formatDate(transaction.date) }}</div>

                    <div class="title">{{$t("order-by")}}:</div>
                    <div class="value">{{ transaction.orderBy }}</div>

                    <div class="title">{{$t("company-name")}}:</div>
                    <div class="value" style="text-transform: capitalize">
                      {{ transaction.subjectName.toLowerCase() }}
                    </div>

                    <div class="title">{{$t("report-type")}}:</div>
                    <div class="value">{{ transaction.reportType }}</div>

                    <div class="title">{{$t("credit-consumed")}}:</div>
                    <div class="value">{{ transaction.creditsConsumed }}</div>

                    <div class="title">{{$t("balance-credit")}}:</div>
                    <div class="value">{{ transaction.balance }}</div>
                  </div>

                  <div v-else class="custom-table-cell-group">
                    <div class="custom-table-cell" style="width: 12%">
                      <span>{{ formatDate(transaction.date) }}</span>
                    </div>
                    <div class="custom-table-cell" style="width: 16%">
                      <span>{{ transaction.orderBy || "-" }}</span>
                    </div>
                    <div
                      class="custom-table-cell"
                      style="width: 32%; text-transform: capitalize"
                    >
                      <span>{{ transaction.subjectName?.toLowerCase() || "-" }}</span>
                    </div>
                    <div class="custom-table-cell" style="width: 16%">
                      <span>{{ transaction.reportType || "-" }}</span>
                    </div>
                    <div class="custom-table-cell" style="width: 12%">
                      <span>{{ transaction.creditsConsumed || "-" }}</span>
                    </div>
                    <div class="custom-table-cell" style="width: 12%">
                      <span>{{ transaction.balance || "-" }}</span>
                    </div>
                  </div>
                </div>
                <div
                  v-if="!this.paymentHistory?.transactions?.length"
                  class="custom-table-row no-data"
                >
                  <div
                    class="custom-table-cell"
                    style="width: -webkit-fill-available; text-align: center"
                    colspan="6"
                  >
                    {{$t("no-tx-found")}}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="wrapper" v-if="toggleButtonValue === 'TopUp'">
        <div class="pre-order-value-wrapper">
          <div class="pre-order-value">{{$t("topup-pre-order")}}</div>
          <div class="pre-order-value-2">{{$t("add-credits")}}</div>
        </div>
        <div class="pre-order-value-wrapper" style="align-self: stretch">
          <div class="pre-order-value">{{$t("purchase-credits")}}</div>
          <input
            type="number"
            required
            class="fields no-arrows"
            id="category"
            :placeholder="$t('enter-credits-placeholder')"
            v-model="creditsToPurchase"
            @input="sendCreditsToApi"
          />
        </div>
        <div class="pre-order-value-wrapper" style="align-self: stretch">
          <div class="pre-order-value-wrapper-2">
            <div class="pre-order-value">
              {{$t("amount")}}
              {{
                this.$root.mobile
                  ? ""
                  : `(${selectedCurrency.code.toUpperCase()})`
              }}
            </div>
            <select v-model="selectedCurrency" class="currency-dropdown">
              <option
                v-for="currency in currencies"
                :value="currency"
                :key="currency.code"
                class="country-option"
              >
                {{ currency.code.toUpperCase() }} - {{ currency.name }}
              </option>
            </select>
          </div>
          <div class="order-value">
            {{ convertedTotal?.toFixed(2) }}
          </div>
        </div>
        <div
          class="pre-order-value-wrapper"
          style="width: -webkit-fill-available"
        >
          <div class="pre-order-value">{{$t("discount")}}</div>
          <div class="discounts-wrapper">
            <div class="pre-order-value-2">{{$t("apply-discount")}}</div>
            <div class="discount-amount-wrapper">
              <div class="discount-radio-buttons">
                <label>
                  <input
                    type="radio"
                    v-model="isDiscountApplied"
                    :value="true"
                    @change="applyDiscount(true)"
                    :disabled="
                      creditsToPurchase === 0 ||
                      creditsToPurchase === '' ||
                      paymentHistory?.discountAvailable === 0
                    "
                  />
                  {{$t("yes")}}
                </label>
                <label>
                  <input
                    type="radio"
                    v-model="isDiscountApplied"
                    :value="false"
                    @change="applyDiscount(false)"
                    :disabled="
                      creditsToPurchase === 0 ||
                      creditsToPurchase === '' ||
                      paymentHistory?.discountAvailable === 0
                    "
                  />
                  {{$t("no")}}
                </label>
              </div>
              <div class="discount-amount">
                {{ selectedCurrency.code.toUpperCase() }}
                {{ convertedDiscount.toFixed(2) }}
              </div>
            </div>
          </div>
        </div>
        <div class="pre-order-value-wrapper">
          <div class="pre-order-value">{{$t("credit-type")}}</div>
          <div class="pre-order-value-2">{{$t("pre-paid")}}</div>
        </div>
        <div class="action-buttons-container">
          <button
            class="primary-button"
            :style="{
              opacity:
                isApiLoading ||
                creditsToPurchase === '' ||
                creditsToPurchase === 0
                  ? 0.6
                  : 1,
            }"
            tabindex="0"
            :disabled="
              isApiLoading ||
              creditsToPurchase === '' ||
              creditsToPurchase === 0
            "
            @click="payNow('ONLINE')"
          >
            {{$t("pay-now")}}
          </button>
          <button
            class="secondary-button"
            :style="{
              opacity:
                isApiLoading ||
                creditsToPurchase === '' ||
                creditsToPurchase === 0
                  ? 0.6
                  : 1,
            }"
            :disabled="
              isApiLoading ||
              creditsToPurchase === '' ||
              creditsToPurchase === 0
            "
            tabindex="0"
            @click="payNow('OFFLINE')"
          >
           {{$t("pay-later")}}
          </button>
          <button class="reset-button" tabindex="0" @click="resetValues">
            {{$t("reset")}}
          </button>
        </div>
      </div>
    </div>
    <div class="frame-32" v-else>
      <p>{{$t("no-credit-mapped")}}</p>
      <p style="margin: 0">
        {{$t("contact-us")}}
      </p>
      <button class="helpdesk-button" @click="$router.push('/contact')">
        {{$t("helpdesk")}}
      </button>
    </div>
  </div>
</template>
<script>
import { GetPaymentHistory, AllCurrencies, TopUpCredits } from "@/api/APIs";
import VueCookies from "vue-cookies";

export default {
  name: "UserProfile",
  components: {},
  data() {
    return {
      // tableHeaders: [
      //   "Order Date",
      //   "Order By",
      //   "Company Name",
      //   "Report Type",
      //   "Credit Consumed",
      //   "Balance Credit",
      // ],
      isApiLoading: false,
      paymentHistory: null,
      creditsToPurchase: "",
      toggleButtonValue: "OverView",
      currencyValue: null,
      currencies: [],
      selectedCurrency: {
        id: 1,
        name: "US Dollar",
        code: "usd",
      },
      isDiscountApplied: false,
      EntityType: VueCookies.get("EntityType"),
    };
  },
  computed: {
    tableHeaders(){
      return [
        this.$t("order-date"),
        this.$t("order-by"),
        this.$t("company-name"),
        this.$t("report-type"),
        this.$t("credit-consumed"),
        this.$t("balance-credit"),
      ]
    },
    creditUtilizationPercentage() {
      const { totalPurchasedCredits = 0, creditBalance = 0 } =
        this.paymentHistory || {};
      return totalPurchasedCredits
        ? Math.round(
            ((totalPurchasedCredits - creditBalance) / totalPurchasedCredits) *
              100
          )
        : 0;
    },
    convertedDiscount() {
      const orderTotalUSD =
        this.creditsToPurchase === 0 || this.creditsToPurchase === ""
          ? 0
          : this.paymentHistory?.discountAvailable;
      if (this.selectedCurrency?.code === "usd") {
        return orderTotalUSD;
      } else {
        const conversionRate = this.currencyValue[this.selectedCurrency?.code];
        return orderTotalUSD * conversionRate;
      }
    },
    convertedTotal() {
      const orderTotalUSD = this.isDiscountApplied
        ? this.paymentHistory?.discountedValueInUsd
        : this.paymentHistory?.creditsToUsd * this.creditsToPurchase;

      if (this.selectedCurrency?.code === "usd") {
        return orderTotalUSD;
      } else {
        const conversionRate = this.currencyValue[this.selectedCurrency?.code];
        return orderTotalUSD * conversionRate;
      }
    },
    convertedRate() {
      const orderTotalUSD = this.isDiscountApplied
        ? this.paymentHistory?.discountedValueInUsd
        : this.paymentHistory?.creditsToUsd * this.creditsToPurchase;

      if (this.selectedCurrency?.code === "usd") {
        return orderTotalUSD;
      } else {
        const conversionRate = this.currencyValue[this.selectedCurrency?.code];
        return conversionRate;
      }
    },
  },
  async mounted() {
    await this.PaymentHistory();
    if (this.paymentHistory?.message === "SUCCESS") {
      this.fetchCurrenciesList();
      this.fetchAPIData();
    }
  },
  methods: {
    applyDiscount(value) {
      this.isDiscountApplied = value;
    },
    async fetchCurrenciesList() {
      try {
        const response = await AllCurrencies();
        this.currencies = await response.allCurrencies;
      } catch (error) {
        this.loginError = "Error occurred during login.";
        console.error(error);
      }
    },
    async fetchAPIData() {
      try {
        const response = await fetch(
          "https://cdn.jsdelivr.net/npm/@fawazahmed0/currency-api@latest/v1/currencies/usd.json"
        );
        if (response.ok) {
          const data = await response.json();
          this.currencyValue = data.usd;
        } else {
          console.error("Failed to fetch API data:", response.statusText);
        }
      } catch (error) {
        console.error("Error occurred while fetching API data:", error);
      }
    },
    async PaymentHistory(credits) {
      try {
        const response = await GetPaymentHistory(credits);
        if (response) {
          this.paymentHistory = response;
          if (response.lowEntityCreditsWarning)
            this.$store.dispatch(
              "setWarning",
              response.lowEntityCreditsWarning
            );
        } else {
          return this.$refs.toastContainer.addToast(
            "Something went wrong. Please try again later.",
            { type: "error" }
          );
        }
      } catch (error) {
        if (error.response && error.response.status !== 403) {
          return this.$refs.toastContainer.addToast(
            "Something went wrong. Please try again later.",
            { type: "error" }
          );
        }
      }
    },
    async payNow(reconciliationMode) {
      if (this.isApiLoading) return;
      this.isApiLoading = true;
      this.$emit("toggleLoader");
      const payload = {
        orderedCredits: this.creditsToPurchase,
        currencyCode: this.selectedCurrency?.code,
        isDiscountApplied: this.isDiscountApplied,
        reconciliationMode: reconciliationMode,
      };
      try {
        const response = await TopUpCredits(payload);
        if (payload.reconciliationMode === "ONLINE") {
          if (response.message === "SUCCESS") {
            if (response?.result?.paymentRequired === true) {
              window.location.href = response?.result?.paymentLink;
            }
          } else {
            return this.$refs.toastContainer.addToast(
              "Something went wrong. Please try again later.",
              { type: "error" }
            );
          }
        } else if (payload.reconciliationMode === "OFFLINE") {
          const url = window.URL.createObjectURL(new Blob([response.data]));
          const now = new Date();
          const day = now.getUTCDate().toString().padStart(2, "0");
          const month = now.toLocaleString("en-US", { month: "short" });
          const year = now.getUTCFullYear();
          const formattedDate = `${day}-${month}-${year}`;
          let filename;
          if (response.headers["x-filename"]) {
            filename = response.headers["x-filename"];
          } else {
            filename = `Credits-proforma-invoice-${formattedDate}.pdf`; // Default filename
          }

          const link = document.createElement("a");
          link.href = url;
          link.setAttribute("download", filename);
          document.body.appendChild(link);
          link.click();
          link.parentNode.removeChild(link);
          setTimeout(() => URL.revokeObjectURL(link.href), 100);
          this.isApiLoading = false;
          this.$emit("disableLoader");
          this.resetValues();
          await this.PaymentHistory();
        }
      } catch (error) {
        if (error.response && error.response.status !== 403) {
          return this.$refs.toastContainer.addToast(
            "Oops! Something went wrong, Please try again later",
            {
              type: "error",
            }
          );
        }
      }
    },
    sendCreditsToApi() {
      if (this.creditsToPurchase && !isNaN(this.creditsToPurchase)) {
        this.PaymentHistory(this.creditsToPurchase);
      }
    },
    resetValues() {
      this.creditsToPurchase = "";
      this.selectedCurrency = {
        id: 1,
        name: "US Dollar",
        code: "usd",
      };
      this.isDiscountApplied = false;
    },
    formatDate(dateString) {
      const options = {
        year: "numeric",
        month: "short",
        day: "numeric",
      };
      return new Intl.DateTimeFormat("en-US", options).format(
        new Date(dateString)
      );
    },
  },
};
</script>
<style scoped>
.frame-35734 {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  justify-content: flex-start;
  width: 100%;
  min-height: 90%;
  padding: 20px;
  background: white;
  border-radius: 0px 16px 16px 16px;
  box-shadow: none !important;
  position: relative;
}
.frame-357341 {
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
  width: 100%;
  border-bottom: 2px solid #cccccc;
}
.frame-35735 {
  color: #224096;
  font-family: "Figtree";
  font-size: 28px;
  text-align: left;
  font-style: normal;
  font-weight: 600;
  line-height: 120%;
  letter-spacing: -0.28px;
  /* width: 100%; */
  padding: 20px 0;
}
.frame-357351 {
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;
  gap: 2vw;
  /* width: 45vw; */
}
.credit-info {
  display: flex;
  flex-direction: column;
  gap: 4px;
  padding: 0;
  margin: 0;
}
.credit-text {
  color: rgba(17, 54, 90, 1);
  font: 500 16px/28px Figtree;
  margin: 0;
  text-align: left;
}
.toggle-button {
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;
  border: 1px solid #224096;
  border-radius: 13px;
  overflow: hidden;
}
.btn1 {
  padding: 10px 20px;
  align-items: center;
  gap: 10px;
  min-width: 185px;
  font-weight: 600;
  color: #fff;
  font-family: "Figtree";
  font-size: 18px;
  font-style: normal;
  font-weight: 600;
  line-height: 120%;
  letter-spacing: -0.18px;
  cursor: pointer;
}
.frame-2 {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: 36px;
  align-self: stretch;
}
.frame-32 {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  width: -webkit-fill-available;
  height: 58vh;
}
.pre-order-value-wrapper {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: 8px;
  width: -webkit-fill-available;
}
.pre-order-value-wrapper-2 {
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
  width: -webkit-fill-available;
}
.pre-order-value {
  color: #224096;
  font-family: "Figtree";
  font-size: 20px;
  font-style: normal;
  font-weight: 600;
  line-height: 120%;
  letter-spacing: -0.2px;
  text-align: left;
}
.currency-dropdown {
  width: auto;
  outline: none;
  border: 1px solid rgba(87, 87, 87, 0.5);
  border-radius: 13px;
  padding: 0 10px;
  height: 27.22px;
  color: #224096;
  font-family: "Figtree";
  font-size: 16px;
}
.order-value {
  color: #224096;
  font-family: "Figtree";
  font-size: 18px;
  font-style: normal;
  font-weight: 600;
  letter-spacing: -0.2px;
}
.pre-order-value-2 {
  color: #224096;
  font-family: "Figtree";
  font-size: 16px;
  font-style: normal;
  font-weight: 500;
  line-height: 28px;
  letter-spacing: -0.16px;
}
.credits {
  font-size: 36px;
  font-weight: 600;
  line-height: 120%;
}
.enterprise-discount {
  display: flex;
  padding: 8px 16px;
  align-items: flex-start;
  gap: 8px;
  border-radius: 16px;
  background: var(--Success-Light-BG, #c9ffc9);
}
.enterprise-discount-title {
  color: var(--Success-Text, #0d630d);
  font-family: "Figtree";
  font-size: 16px;
  font-style: normal;
  font-weight: 500;
  line-height: 28px;
  letter-spacing: -0.16px;
}
.line {
  width: 100%;
  height: 2px;
  opacity: 0.2;
  background: #3e4855;
}
.wrapper {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: 36px;
  align-self: stretch;
}
.fields {
  height: 40px;
  outline: none;
  border: 1px solid rgba(17, 54, 90, 0.4);
  border-radius: 16px;
  padding: 0px 20px;
  align-self: stretch;
}
.discounts-wrapper {
  display: flex;
  width: -webkit-fill-available;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
}
.discount-radio-buttons {
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;
  gap: 10px;
}
.discount-radio-buttons input[type="radio"] {
  accent-color: #224096;
  width: 15px;
  height: 15px;
}
.discount-amount-wrapper {
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;
  gap: 20px;
}
.discount-amount {
  border-radius: 16px;
  border: 1px solid #22409666;
  display: flex;
  padding: 12px 16px;
  justify-content: center;
  align-items: center;
}
.action-buttons-container {
  display: flex;
  gap: 16px;
  text-align: center;
  letter-spacing: 0.18px;
  justify-content: flex-start;
  flex-wrap: wrap;
  font: 600 18px Figtree;
}

.primary-button {
  flex: 1;
  min-width: 150px;
  border-radius: 13px;
  background: var(--Dark-Blue, #224096);
  color: var(--Other-WHITE, #fff);
  text-transform: capitalize;
  height: 40px;
  width: 200px;
  border: none;
  cursor: pointer;
}

.secondary-button {
  border-radius: 13px;
  background-color: rgba(255, 255, 255, 1);
  display: flex;
  min-width: 200px;
  align-items: center;
  gap: 10px;
  color: rgba(17, 54, 90, 1);
  justify-content: center;
  height: 40px;
  border: 2px solid rgba(17, 54, 90, 1);
  cursor: pointer;
}

.button-text {
  align-self: stretch;
  margin: auto 0;
}

.download-icon {
  aspect-ratio: 1;
  object-fit: contain;
  object-position: center;
  width: 20px;
  align-self: stretch;
  margin: auto 0;
}

.reset-button {
  width: 200px;
  border-radius: 13px;
  background-color: rgba(5, 29, 52, 0.1);
  color: rgba(5, 29, 52, 1);
  white-space: nowrap;
  height: 40px;
  border: none;
  cursor: pointer;
}

.visually-hidden {
  position: absolute;
  width: 1px;
  height: 1px;
  padding: 0;
  margin: -1px;
  overflow: hidden;
  clip: rect(0, 0, 0, 0);
  white-space: nowrap;
  border: 0;
}
.progress-bar {
  width: 100%;
  height: 24px;
  border-radius: 16px;
  overflow: hidden;
  margin-top: 5px;
  border: 1px solid #224096;
}
.progress {
  height: 100%;
  border-radius: 5px;
}
.table-container.scrollable {
  max-height: 400px;
  overflow-y: auto;
  border-radius: 8px;
}
.table-container {
  margin-top: 20px;
  overflow-x: auto;
  border-radius: 8px;
  border: 1px solid #83d7d8;
  align-self: stretch;
}
.custom-table {
  display: flex;
  flex-direction: column;
  width: 100%;
}

.custom-table-header {
  display: flex;
  position: sticky;
  top: 0;
  background-color: #E0F5FF;
  color: #224096;
  z-index: 10;
}

.custom-table-body {
  display: flex;
  flex-direction: column;
}

.custom-table-row {
  display: flex;
}

.custom-table-cell {
  padding: 10px;
  text-align: left;
}

.header-cell {
  font-weight: bold;
  align-content: center;
}

.no-data {
  text-align: center;
  font-style: italic;
  color: #888;
}
.transaction-table {
  width: 100%;
  border-collapse: collapse;
  border-spacing: 0;
  background-color: #ffffff;
  overflow: hidden;
  font-family: "Figtree";
  font-size: 16px;
  border-radius: 8px;
}
.transaction-table th,
.transaction-table td {
  text-align: left;
  padding: 10px;
}
.transaction-table thead {
  background-color: #E0F5FF;
}
.transaction-table thead th {
  font-weight: bold;
}
.transaction-table tbody .no-data {
  text-align: center;
  color: #888;
}
.no-arrows {
  -moz-appearance: textfield;
  -webkit-appearance: none;
  appearance: none;
}
.no-arrows::-webkit-inner-spin-button,
.no-arrows::-webkit-outer-spin-button {
  -webkit-appearance: none;
  margin: 0;
}
.helpdesk-button {
  background-color: #224096;
  color: white;
  border: none;
  border-radius: 5px;
  cursor: pointer;
  font-size: 16px;
  margin-top: 10px;
}
.helpdesk-button:hover {
  background-color: #0e2d4b;
}
.grid-container {
  display: grid;
  grid-template-columns: 40% 60%;
  gap: 10px;
  width: 100%;
  padding: 10px;
  border: 1px solid #224096;
  border-radius: 10px;
  background: white;
}
.title {
  font-weight: bold;
  text-align: left;
}
.value {
  overflow-wrap: break-word;
  text-align: left;
}
.custom-table-cell-group {
  display: flex;
  justify-content: space-between;
  width: 100%;
}
@media only screen and (max-width: 767px) {
  .frame-35735 {
    padding: 15px 0;
    font-size: 18px;
  }
  .btn1 {
    width: 50%;
    min-width: 0%;
    padding: 10px 10px;
    font-size: 14px;
  }
  .frame-35734 {
    gap: 15px;
    padding: 15px;
  }
  .toggle-button {
    width: -webkit-fill-available;
  }
  .frame-2 {
    gap: 25px;
  }
  .pre-order-value {
    font-size: 18px;
  }
  .pre-order-value-2 {
    text-align: left;
  }
  .credits {
    font-size: 28px;
  }
  .wrapper {
    gap: 25px;
  }
  .currency-dropdown {
    width: 50%;
  }
  .discounts-wrapper {
    flex-direction: column;
    align-items: flex-start;
  }
  .discount-amount-wrapper {
    justify-content: space-between;
    gap: 20px;
    width: -webkit-fill-available;
  }
  .action-buttons-container {
    width: -webkit-fill-available;
    gap: 8px;
  }
  .primary-button,
  .secondary-button,
  .reset-button {
    width: calc((100% - 16px) / 3) !important;
    min-width: auto;
  }
  .custom-table-row {
    flex-direction: column;
    align-items: flex-start;
  }
  .table-container {
    border: none;
  }
  .custom-table-body {
    gap: 10px;
    background: #dfecf8;
    padding: 10px;
  }
  .progress-bar {
    height: 18px;
  }
}
</style>
